module.exports = __webpack_public_path__ + "img/箱包3.ea8862ea.png";